import { Card, generateCardId } from './Card';
import { CardColor, CardType } from '@/types/card';
import { GAME_CONFIG } from '@/utils/constants';

/**
 * デッキクラス
 * カードの生成、シャッフル、ドロー機能を提供
 */
export class Deck {
  private cards: Card[] = [];

  constructor() {
    this.initialize();
  }

  /**
   * デッキを初期化（全カード生成）
   */
  private initialize(): void {
    // 3色（赤、青、黄）のカードを生成
    for (const color of [CardColor.RED, CardColor.BLUE, CardColor.YELLOW]) {
      // 数字カード 0（各色1枚）
      this.cards.push(new Card(generateCardId(), color, CardType.NUMBER, 0));

      // 数字カード 1-9（各色2枚ずつ）
      for (let value = 1; value <= 9; value++) {
        this.cards.push(new Card(generateCardId(), color, CardType.NUMBER, value));
        this.cards.push(new Card(generateCardId(), color, CardType.NUMBER, value));
      }

      // Skipカード（各色2枚）
      this.cards.push(new Card(generateCardId(), color, CardType.SKIP));
      this.cards.push(new Card(generateCardId(), color, CardType.SKIP));

      // Reverseカード（各色2枚）
      this.cards.push(new Card(generateCardId(), color, CardType.REVERSE));
      this.cards.push(new Card(generateCardId(), color, CardType.REVERSE));

      // Draw2カード（各色2枚）
      this.cards.push(new Card(generateCardId(), color, CardType.DRAW_TWO));
      this.cards.push(new Card(generateCardId(), color, CardType.DRAW_TWO));
    }

    // ワイルドカード（4枚）
    for (let i = 0; i < GAME_CONFIG.WILD_CARDS.WILD; i++) {
      this.cards.push(new Card(generateCardId(), CardColor.WILD, CardType.WILD));
    }

    // ワイルドドロー4カード（4枚）
    for (let i = 0; i < GAME_CONFIG.WILD_CARDS.WILD_DRAW_FOUR; i++) {
      this.cards.push(new Card(generateCardId(), CardColor.WILD, CardType.WILD_DRAW_FOUR));
    }
  }

  /**
   * デッキをシャッフル（Fisher-Yatesアルゴリズム）
   */
  shuffle(): void {
    for (let i = this.cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
    }
  }

  /**
   * カードをドロー
   * @param count ドローするカード枚数
   * @returns ドローしたカード配列
   */
  draw(count: number = 1): Card[] {
    return this.cards.splice(0, count);
  }

  /**
   * 残りカード枚数を取得
   */
  getCount(): number {
    return this.cards.length;
  }

  /**
   * カードをデッキに追加
   * @param cards 追加するカード配列
   */
  addCards(cards: Card[]): void {
    this.cards.push(...cards);
  }

  /**
   * デッキ内の全カードを取得（参照コピー）
   */
  getAllCards(): Card[] {
    return [...this.cards];
  }
}
